var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8999 5.33435C3.93428 5.33435 4.7749 6.17498 4.7749 7.20935V14.125C4.7749 15.1594 3.93428 16 2.8999 16C1.86553 16 1.0249 15.1594 1.0249 14.125V7.20935C1.0249 6.17185 1.8624 5.33435 2.8999 5.33435Z",
    fill: "#E09200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C9.03437 0 9.875 0.840625 9.875 1.875V14.125C9.875 15.1594 9.03437 16 8 16C6.96563 16 6.125 15.1594 6.125 14.125V1.875C6.125 0.840625 6.96563 0 8 0Z",
    fill: "#E09200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1001 10.6656C14.1345 10.6656 14.9751 11.5063 14.9751 12.5406V14.125C14.9751 15.1594 14.1345 16 13.1001 16C12.0657 16 11.2251 15.1594 11.2251 14.125V12.5406C11.2251 11.5063 12.0657 10.6656 13.1001 10.6656Z",
    fill: "#E09200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowBar);
export default __webpack_public_path__ + "static/media/yellowBar.d291b80a0ad89e76958d38c4541f7239.svg";
export { ForwardRef as ReactComponent };